module.exports = __webpack_public_path__ + "img/jump-out-warning-example.2460e665.png";